import type { Team } from '@/systems/Combat';
import { Enemy } from '@/entities/Enemy';

/**
 * Ally — temporary player-team combatant spawned by the Backup Meter summon.
 * Reuses Enemy AI entirely; only the team affiliation differs so the combat
 * system keeps friendly fire suppressed between allies and the player.
 */
export class Ally extends Enemy {
  override readonly team: Team = 'player';
}
